<mat-card appearance="outlined">
    <div class="header">
        <div>
            <mat-card-title>
                <strong>{{ heading }}</strong>
            </mat-card-title>
        </div>
        <div class="header-spacer"></div>
        <span *ngIf="canEdit" class="pull-right">
            <button
                mat-icon-button
                [attr.aria-label]="listSaveEditLabel(isEditing)"
                [matTooltip]="isEditing ? 'Save your changes' : 'Edit list'"
                (click)="click()"
            >
                <mat-icon>{{ isEditing ? icons.Save : icons.Edit }}</mat-icon>
            </button>
        </span>
    </div>
    <mat-card-content>
        <mat-progress-bar
            *ngIf="isLoading || isSaving"
            mode="indeterminate"
            aria-label="list progress"
        ></mat-progress-bar>
        <div *ngIf="error" class="error">
            <em>Error: {{ error }}</em>
        </div>
        <div *ngIf="!isLoading && lists">
            <div
                cdkDropList
                *ngIf="hasLists(); else empty"
                [cdkDropListData]="lists"
                (cdkDropListDropped)="drop($event)"
            >
                <div
                    *ngFor="let list of lists"
                    [cdkDragDisabled]="!isEditing"
                    class="boxed"
                    cdkDrag
                >
                    <div *ngIf="list.active" class="row">
                        <a
                            [routerLink]="['/lists', list.id]"
                            [attr.aria-label]="
                                'View ' +
                                list.name +
                                ' list. list id: ' +
                                list.id
                            "
                        >
                            {{ list.name }}
                        </a>
                        <ng-container
                            [ngTemplateOutlet]="isEditing ? remove : count"
                            [ngTemplateOutletContext]="{ list: list }"
                        ></ng-container>
                    </div>
                </div>
            </div>
        </div>
    </mat-card-content>
    <mat-card-actions *ngIf="canEdit">
        <button
            mat-icon-button
            aria-label="Add list item"
            (click)="openNewListDialog()"
        >
            <mat-icon>add</mat-icon>
        </button>
    </mat-card-actions>
</mat-card>

<ng-template #empty>{{ error ? null : "No Lists Found" }}</ng-template>

<ng-template #newDialog>
    <h1 mat-dialog-title>Create new {{ type }} list</h1>
    <div mat-dialog-content>
        <mat-form-field appearance="fill">
            <mat-label>Enter a list name</mat-label>
            <input matInput [(ngModel)]="listName" />
        </mat-form-field>
    </div>
    <div mat-dialog-actions>
        <button mat-button [disabled]="!listName" (click)="createNewList()">
            Save
        </button>
        <button mat-button mat-dialog-close>Cancel</button>
    </div>
</ng-template>

<ng-template #remove let-list="list">
    <button (click)="deactivateListItem(list)" mat-icon-button>
        <mat-icon>close</mat-icon>
    </button>
</ng-template>

<ng-template #count let-list="list">
    <div class="count">{{ asList(list).total }}</div>
</ng-template>
